"use client";

import ProductCard from "@/components/product-card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { ProductType } from "@/types/product.type";

export default function Products({ products }: { products: ProductType[] }) {
  return (
    <Swiper
      modules={[Autoplay, Navigation]}
      autoplay={{ delay: 2500, disableOnInteraction: false }}
      spaceBetween={16}
      slidesPerView="auto"
      loop
      navigation
    >
      {products.map((product, index) => (
        <SwiperSlide key={index} className="md:max-w-[300px] max-w-[165px]">
          <ProductCard product={product} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
